"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import styles from "./Navigation.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../store/SliceTheme";
import { RxCross2, RxHamburgerMenu } from "react-icons/rx";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { IoIosLogOut } from "react-icons/io";
import { login, logout } from "@/store/authSlice";
import { signOut, useSession } from "next-auth/react";

const PiSunLight = dynamic(() =>
  import("react-icons/pi").then((mod) => mod.PiSunLight),
);
const PiMoonStarsLight = dynamic(() =>
  import("react-icons/pi").then((mod) => mod.PiMoonStarsLight),
);

export default function Navigation() {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.mode);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const cartItems = useSelector((state) => state.cart.items || []);
  const { data: session, status } = useSession();
  const itemCount = cartItems.reduce(
    (sum, item) => sum + (item.quantity || 0),
    0,
  );
  const reduxAuth = useSelector((state) => state.auth);
  const isAuthenticated =
    status === "authenticated" || reduxAuth?.isAuthenticated;
  const userEmail = session?.user?.email || reduxAuth?.user?.email || "";

  useEffect(() => {
    if (status === "authenticated") {
      dispatch(
        login({
          id: session?.user?.id || "",
          email: session?.user?.email || "",
          name: session?.user?.name || "",
          image: session?.user?.image || "",
          // isAdmin: Boolean(session?.user?.isAdmin),
        }),
      );
    } else if (status === "unauthenticated") {
      dispatch(logout());
    }
  }, [
    dispatch,
    status,
    session?.user?.id,
    session?.user?.email,
    session?.user?.name,
    session?.user?.image,
  ]);

  const navItems = [
    { href: "/", label: "Home", match: pathname === "/" },
    {
      href: "/products",
      label: "Products",
      match: pathname === "/products",
    },
    {
      href: "/cart",
      label: "Cart",
      match: pathname === "/cart",
    },
    { href: "/contact", label: "Contact", match: pathname === "/contact" },
    { href: "/orders", label: "Orders", match: pathname === "/orders" },

    // !isAuthenticated && {
    //   href: "/login",
    //   label:
    //   match: pathname === "/login",
    // },
  ];

  // useEffect(() => {
  //   if (
  //     pathname === "/admin" ||
  //     pathname === "/contact" ||
  //     pathname === "/login"
  //   ) {
  //     if (theme !== "light") {
  //       dispatch(toggleTheme());
  //     }
  //   }
  // }, [pathname, theme, dispatch]);

  // const handleMui = () => {
  //   if (
  //     pathname === "/admin" ||
  //     pathname === "/contact" ||
  //     pathname === "/login"
  //   ) {
  //     Swal.fire({
  //       icon: "info",
  //       title: "Theme Locked",
  //       text: "You cannot change theme on the Form page.",
  //     });
  //   }
  // };
  const handleLogout = async () => {
    try {
      await signOut({ redirect: false });
      dispatch(logout());
      setSidebarOpen(false);
      Swal.fire({
        icon: "success",
        title: "Logged out",
        text: "You have been signed out successfully.",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Logout failed",
        text: error.message || "Please try again.",
      });
    }
  };
  return (
    <>
      <nav className={styles.nav}>
        {pathname === "/" && (
          <div className={styles.offerBanner}>
            10% OFF on Diamonds + 50% OFF on Making Charges.
          </div>
        )}

        <div className={styles.container}>
          <Link href="/" className={styles.logo}>
            <p className={styles.gradientText}>Geer</p>
          </Link>

          <button
            className={styles.menuToggle}
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <RxHamburgerMenu />
          </button>

          <div className={styles.mainLinks}>
            {isAuthenticated && userEmail && (
              <span className={styles.userEmail}>{userEmail}</span>
            )}
            {navItems.filter(Boolean).map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className={`${styles.navLink} ${
                  item.match ? styles.active : ""
                }`}
              >
                {item.label}{" "}
                {item.label === "Cart" && (
                  <span className={styles.cartCount}>{itemCount}</span>
                )}
              </Link>
            ))}

            <button
              onClick={() => {
                // handleMui();
                dispatch(toggleTheme());
              }}
              className={styles.themeToggle}
            >
              {theme === "light" ? <PiSunLight /> : <PiMoonStarsLight />}
              <span>Theme</span>
            </button>

            {isAuthenticated ? (
              <button onClick={handleLogout} className={styles.themeToggle}>
                <IoIosLogOut />
                Logout
              </button>
            ) : (
              <Link href="/login" className={styles.themeToggle}>
                Login
              </Link>
            )}
          </div>
        </div>
      </nav>

      <div className={`${styles.sidebar} ${sidebarOpen ? styles.open : ""}`}>
        <button
          className={styles.closeButton}
          onClick={() => setSidebarOpen(false)}
          aria-label="Close menu"
        >
          <RxCross2 />
        </button>
        <div className={styles.sidebarHeader}>
          <span>GEER</span>
          <h2>Explore</h2>
          <p>Find something made to be treasured.</p>
        </div>
        {isAuthenticated && userEmail && (
          <span className={styles.userEmail}>{userEmail}</span>
        )}
        {navItems.filter(Boolean).map((item) => (
          <Link
            key={item.href}
            href={item.href}
            className={`${styles.sidebarLink} ${
              item.match ? styles.active : ""
            }`}
            aria-current={item.match ? "page" : undefined}
            onClick={() => setSidebarOpen(false)}
          >
            {item.label}{" "}
            {item.label === "Cart" && (
              <span className={styles.cartCount}>{itemCount}</span>
            )}
          </Link>
        ))}

        <button
          className={styles.sidebarLink}
          onClick={() => {
            setSidebarOpen(false);
            dispatch(toggleTheme());
            // handleMui();
          }}
        >
          {theme === "light" ? <PiSunLight /> : <PiMoonStarsLight />} Theme
        </button>

        {isAuthenticated ? (
          <button onClick={handleLogout} className={styles.sidebarLink}>
            <IoIosLogOut />
            Logout
          </button>
        ) : (
          <Link href="/login" className={styles.sidebarLink}>
            Login
          </Link>
        )}
      </div>
      {sidebarOpen && (
        <div
          className={styles.sidebarBackdrop}
          onClick={() => setSidebarOpen(false)}
          role="button"
          aria-hidden="true"
        />
      )}
    </>
  );
}
